import { MapPin, Award, Heart } from "lucide-react";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section-padding bg-white"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
            About Us
          </p>
          <h2 className="section-heading">Local knowledge. Real results.</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80"
                alt="Kellie Williams - StayCraft Studio founder"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border border-gold/30 -z-10" />
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-gold-light -z-10" />
          </div>

          {/* Content */}
          <div>
            <p className="text-lg text-bark leading-relaxed mb-6">
              I'm Kellie Williams, and I've called Bribie Island home for over a
              decade. What started as managing my own Airbnb property quickly
              evolved into a passion for helping others unlock the full
              potential of their holiday rentals.
            </p>

            <p className="text-bark-light leading-relaxed mb-6">
              After years of working in hospitality and seeing firsthand what
              makes guests choose one property over another, I founded StayCraft
              Studio to bring that insider knowledge to property owners across
              Southeast Queensland.
            </p>

            {/* Pull Quote */}
            <blockquote className="pull-quote">
              "Every property has a story worth telling. I help hosts tell it in
              a way that guests can't resist."
            </blockquote>

            <p className="text-bark-light leading-relaxed mb-8">
              What sets us apart is simple: I don't just manage listings from
              behind a screen. I know every beach, every café, every hidden gem
              on Bribie Island. That local knowledge translates directly into
              better guest experiences and, ultimately, better reviews and more
              bookings for you.
            </p>

            {/* Features */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-gold-light text-gold flex items-center justify-center mx-auto mb-3">
                  <MapPin size={24} />
                </div>
                <p className="text-sm text-bark-light">
                  Bribie Island
                  <br />
                  Based
                </p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gold-light text-gold flex items-center justify-center mx-auto mb-3">
                  <Award size={24} />
                </div>
                <p className="text-sm text-bark-light">
                  Superhost
                  <br />
                  Status
                </p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gold-light text-gold flex items-center justify-center mx-auto mb-3">
                  <Heart size={24} />
                </div>
                <p className="text-sm text-bark-light">
                  Hospitality
                  <br />
                  First
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Service Area */}
        <div className="mt-20 pt-12 border-t border-bark/10 text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
            Areas We Serve
          </p>
          <p className="text-2xl font-serif text-bark">
            Bribie Island · Caloundra · Noosa · Brisbane
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
